import { useState } from "react";
export const useFlame = () => {
    const [ referrals, setReferrals ] = useState(0);
    return [ referrals, setReferrals ]
}